import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormService } from "../../services/form.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-modal-header",
  templateUrl: "./modal-header.component.html",
  styleUrls: ["./modal-header.component.scss"],
  providers: [FormService]
})
export class ModalHeaderComponent implements OnInit {
  @Input() modalTitle?: string;
  @Input() modalTitles?: string[];
  @Output() closeModal = new EventEmitter<string>();

  showCloseButton = true;
  constructor() {
    if (environment.isFormPreview) {
      this.showCloseButton = false;
    }
  }

  ngOnInit() {

  }
}
